import component from './preloader.vue'

export default component
